// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_snap_joint/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_snap_joint: ModuleSchema = {
  "id": "core_snap_joint",
  "uniqueId": "B3D_SNAP1",
  "createdAt": "2026-10-02T02:40:00Z",
  "updatedAt": "2026-10-28T14:58:32.724Z",
  "label": "Snap Joint",
  "description": "Horizontal Swivel Snap Joint built from core_geometry/snap_joint.h",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_SNAP01",
    "snap-fit",
    "swivel-joint"
  ],
  "sliders": [
    {
      "key": "displayMode",
      "label": "Display Mode (0:Both, 1:Tongue, 2:Socket)",
      "min": 0,
      "max": 2,
      "default": 0,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "enabled": true,
      "visible": true
    },
    {
      "key": "pinDiameter",
      "label": "Pivot Pin Outer Diameter",
      "min": 4,
      "max": 5.2,
      "default": 5,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "pinHeight",
      "label": "Joint Height (Z)",
      "min": 4,
      "max": 10,
      "default": 8,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "armWidth",
      "label": "Neck Arm Width",
      "min": 1.2,
      "max": 3.4,
      "default": 3,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "slitWidth",
      "label": "Spring Slit Width",
      "min": 0,
      "max": 1.2,
      "default": 0.5,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "socketDepth",
      "label": "Recessed Socket Depth",
      "min": 2.5,
      "max": 8,
      "default": 2.8,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "jointClearance",
      "label": "Radial Swivel Clearance",
      "min": 0.15,
      "max": 0.6,
      "default": 0.3,
      "step": 0.05,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "separationGap",
      "label": "Separation Gap (Exploded View)",
      "min": 0,
      "max": 20,
      "default": 0,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "socket_part",
      "label": "Recessed Socket Cavity",
      "default": "#10B981",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "tongue_part",
      "label": "Snap Tongue with Pin",
      "default": "#3B82F6",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "obj_socket",
      "label": "Female Socket Test Block",
      "name": "Female Socket Test Block",
      "color": "#10B981",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "socket_part",
          "label": "Recessed Socket Cavity",
          "name": "Recessed Socket Cavity",
          "groupId": 1,
          "colorKey": "socket_part",
          "defaultColor": "#10B981",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "obj_tongue",
      "label": "Male Swivel Snap Tongue",
      "name": "Male Swivel Snap Tongue",
      "color": "#3B82F6",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "tongue_part",
          "label": "Snap Tongue with Pin",
          "name": "Snap Tongue with Pin",
          "groupId": 0,
          "colorKey": "tongue_part",
          "defaultColor": "#3B82F6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Joint Assembly"
    },
    {
      "id": "0",
      "label": "Download STL - Male Snap Tongue"
    },
    {
      "id": "1",
      "label": "Download STL - Female Socket Block"
    }
  ]
};
